export const clearInactivityStorage = () =>
  localStorage.removeItem('nextLogout');
